export function classNames(defaultClass = '', customClasses = {}) {
	const classes = [];
	if (Array.isArray(defaultClass)) {
		defaultClass.forEach((className) => classes.push(className));
	} else {
		classes.push(defaultClass);
	}
	if (Object.keys(customClasses).length) {
		Object.entries(customClasses).forEach(([name, value]) => {
			if (value) {
				classes.push(name);
			}
		});
	}
	return classes.join(' ');
}

export default classNames